<template>
    <v-content :class="backColor">
        <div :class="{'mt-5': $vuetify.breakpoint.smAndUp}">
            <router-view></router-view>
        </div>

        <div class="caption text-center mt-8 mb-6">
                Copyright © 2020 Young Potential Development LLC. All rights reserved.
            </div>
    </v-content>
</template>

<script>
export default {
    computed: {
        backColor() {
            if (this.$route.path == '/welcome' || this.$route.path == '/aviso-de-privacidad' || this.$route.path == '/terms-and-conditions') {
                return 'white';
            }

            return 'outsider';
        }
    }
}
</script>
